export const VERSION = '1.25.2';
